module.exports = __webpack_public_path__ + "static/media/smartbrain.7c41ce9e.png";